import PropTypes from 'prop-types';
import React, { memo, PureComponent } from 'react';

import { FlexView } from '@cuemath/comps';
import { Grid } from 'semantic-ui-react';

import {
  CONTACT_DETAILS_LABELS,
  FIELD_TYPE,
  PARENT_DEMOGRAPHICS_DETAILS_LABELS,
} from 'constants/parent-profile';
import { Heading, InfoWrapper, Wrapper } from '../utils/styled-components';
import { FieldContainer, LinkContainer } from '../utils/comps';

class ParentProfile extends PureComponent {
  static propTypes = {
    parentProfileInfo: PropTypes.shape({}).isRequired,
  };

  renderParentProfileAccordion = (
    heading = '',
    fields = [],
    type = '',
    renderer = () => {},
  ) => {
    return (
      <FlexView>
        <Heading>{heading}</Heading>
        <InfoWrapper>
          <Grid>{renderer(fields, type)}</Grid>
        </InfoWrapper>
      </FlexView>
    );
  };

  renderColumnContainersInGrid = (fields = [], type) => {
    return fields.map((row = [], index) => (
      <Grid.Row key={index}>
        {row.map(({ label, value, width }) => {
          return (
            <React.Fragment key={label}>
              {type === FIELD_TYPE.FIELD && <>{FieldContainer(label, value, width)}</>}
              {type === FIELD_TYPE.LINK && <>{LinkContainer(label, value, width)}</>}
            </React.Fragment>
          );
        })}
      </Grid.Row>
    ));
  };

  renderParentDemograpicDetails = parentProfileInfo => {
    const {
      first_name: firstName,
      id,
      last_name: lastName,
      is_active: state,
      country_code: countryCode,
      phone,
      email,
    } = parentProfileInfo;

    const { FIRST_NAME, LAST_NAME, ID, STATE } = PARENT_DEMOGRAPHICS_DETAILS_LABELS;
    const { HEADING, COUNTRY_CODE, PHONE, EMAIL } = CONTACT_DETAILS_LABELS || {};

    const fieldsData = [
      [
        {
          label: FIRST_NAME,
          value: firstName,
          width: 8,
        },
        {
          label: LAST_NAME,
          value: lastName,
          width: 8,
        },
      ],
      [
        { label: STATE, value: (state ?? false).toString().toUpperCase(), width: 8 },
        { label: EMAIL, value: email, width: 8 },
      ],
      [
        {
          label: COUNTRY_CODE,
          value: countryCode,
          width: 8,
        },
        { label: PHONE, value: phone, width: 8 },
      ],
      [{ label: ID, value: id, width: 8 }],
    ];

    return this.renderParentProfileAccordion(
      HEADING,
      fieldsData,
      FIELD_TYPE.FIELD,
      this.renderColumnContainersInGrid,
    );
  };

  render() {
    const { parentProfileInfo = {} } = this.props;

    return (
      <Wrapper>
        <div>{this.renderParentDemograpicDetails(parentProfileInfo)}</div>
      </Wrapper>
    );
  }
}
export default memo(ParentProfile);
